import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { debounce } from '@comeon/utility';
import { saveBottomReached, saveSafariToolbarHidden, saveScrollDirection } from './ducks/index.js';
import { isIOS } from '../../utils/layout-utils.js';

function checkBottomReached(scrollTop, innerHeight, offsetHeight) {
	const offset = scrollTop + innerHeight;
	return offset === offsetHeight;
}
class Scroll extends PureComponent {
	state = {
		direction: '',
		isScrolling: false,
		scrollPosition: 0
	};

	updateSafariToolbarsHidden = debounce(
		innerHeight => this.props.dispatch(saveSafariToolbarHidden(innerHeight)),
		10,
		{ trailing: true }
	);

	timeout;

	componentDidMount() {
		this._isMounted = true;
		if (this.props.attachToWindow) {
			window.addEventListener('scroll', this.handleScroll, {
				passive: true,
				capture: true
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
		if (this.props.attachToWindow) {
			window.removeEventListener('scroll', this.handleScroll);
		}
		this._isMounted = false;
	}

	updateScrollDirection = scrollDirection => this.props.dispatch(saveScrollDirection(scrollDirection));

	setNotScrolling = () => {
		if (this._isMounted) {
			this.setState({ isScrolling: false });
		}
	};

	updateBottomReached = bottomReached => this.props.dispatch(saveBottomReached(bottomReached));

	handleScroll = event => {
		if (!this._isMounted) {
			return;
		}

		const { scrollPosition, direction } = this.state;
		const { scrollTop = window.scrollY >= 0 ? window.scrollY : 0, scrollHeight = document.body.scrollHeight } =
			event.currentTarget;
		const scrollScope = scrollHeight - window.innerHeight - 10;
		const { offsetHeight } = document.documentElement;

		if (scrollTop >= 0 && scrollPosition !== scrollTop) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.setNotScrolling, 200);
			const saveScroll = newDirection => {
				const scrollDirection = scrollTop > scrollScope ? '' : newDirection;
				if (scrollDirection !== direction) {
					this.updateScrollDirection(scrollDirection);
				}
				this.setState({
					isScrolling: true,
					direction: scrollDirection,
					scrollPosition: scrollTop
				});
			};

			if (scrollPosition > scrollTop) {
				saveScroll('top');
			} else if (scrollPosition < scrollTop) {
				saveScroll('bottom');
			}

			this.updateBottomReached(checkBottomReached(scrollTop, window.innerHeight, offsetHeight));

			if (isIOS()) {
				this.updateSafariToolbarsHidden(window.innerHeight);
			}
		} else {
			this.setState({
				isScrolling: true
			});
		}

		const { onScroll } = this.props;
		if (onScroll) {
			onScroll(this.state);
		}
	};

	render() {
		return typeof this.props.children === 'function'
			? this.props.children({
					...this.state,
					handleScroll: this.handleScroll
				})
			: this.props.children || null;
	}
}

export default connect()(Scroll);
